import { referenceInterface } from '@ardoq/reference-interface';
import {
  type RawGraphEdge2,
  getWorkspaceEdgeLabelReferenceId,
} from '@ardoq/graph';

export const resolveEdgeReferenceDisplayLabel = (
  item: RawGraphEdge2
): string | null => {
  const referenceId = getWorkspaceEdgeLabelReferenceId(item);
  return referenceId === null
    ? null
    : referenceInterface.getDisplayLabel(referenceId);
};

export const resolveEdgeReferenceDisplayLabels = (
  referenceList: readonly RawGraphEdge2[]
): Map<string, string | null> =>
  new Map(
    referenceList.map(item => [item.id, resolveEdgeReferenceDisplayLabel(item)])
  );
